module.exports = __webpack_public_path__ + "img/404.08d7ba3c.png";